module.exports = __webpack_public_path__ + "static/media/683.dcd9821c.png";